import React, { useMemo } from 'react';

const formatCycleTime = (seconds) => {
  if (seconds < 60) return `${Math.round(seconds)} seconds`;
  if (seconds < 3600) return `${Math.round(seconds / 6) / 10} minutes`;
  if (seconds < 86400) return `${Math.round(seconds / 360) / 10} hours`;
  return `${Math.round(seconds / 8640) / 10} days`;
};

function Metrics({ percentiles, processedData }) {
  const reversedPercentiles = useMemo(
    () => [...percentiles].reverse(),
    [percentiles]
  );
  return (
    <div>
      {reversedPercentiles.map((x) => {
        const latestValues =
          processedData.movingAverage[processedData.movingAverage.length - 1];
        return (
          <div key={x} style={{ marginBottom: '1rem' }}>
            <div style={{ fontSize: '0.8rem', color: '#666' }}>
              {Math.round(x * 100)}th percentile
            </div>
            <div style={{ fontSize: '1.2rem', fontWeight: 500 }}>
              {formatCycleTime(latestValues[x])}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Metrics;
